import { state } from './state'

function post(data) {
  if (state.noLogging) {
    return
  }
  fetch("/analytics", {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: "POST",
    body: JSON.stringify(data)
  })
}

export function updatePath(district, answers = [], weightedOpinion, pathname) {
  if (pathname) {
    let answerPath = answers.map(answer => `${answer.question}=${answer.question === weightedOpinion ? Math.round(answer.opinion * 2.1) : Math.round(answer.opinion)}`).join('&')
    let path = `/${state.language === 'fi' ? 'tulokset' : 'en/results'}?d=${district}&${answerPath}`
    window.history.pushState({ district, answers, weightedOpinion }, false, path)

    logPath()
  } else {
    window.history.pushState({ district, answers, weightedOpinion }, false)
  }
}

export function logPath() {
  post({ href: window.location.href })
}